// flowgenIgnore
declare global {
  interface Window {
    Rover: Record<string, any>;
  }
}

window.Rover = window.Rover || {};
export default window.Rover;



// WEBPACK FOOTER //
// ../globals/Rover.ts